export default function CONTACT (){
  $(()=>{
    const currentUrl = window.location.href;
    if (!currentUrl.includes("thanks")) {
      let body = document.querySelector("body");
      body.classList.add("noheader");
    }
  })
}